import React from "react";

import OgImage from "../../../assets/landingPages/homePage/Hero.png";

import { ReactComponent as SuccessIcon } from "../../../assets/payment/success-symbol.svg";
import { ReactComponent as BottomEllips } from "../../../assets/payment/success-br-ellips.svg";
import useLocales from "../../../hooks/useLocales";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
const PaymentSuccess = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { getPaymentStripe } = useSelector((state) => state?.paymentStripes);
  const paymentData = getPaymentStripe?.data;
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Payment Success | Bil.Bio</title>
        <meta property="og:title" content="Payment Success | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="px-6">
        <div
          className={`rounded-[20px] relative z-30 py-[60px] md:py-5 p-[20px] mt-[60px] md:mt-[100px] mb-[50px] md:mb-[150px] bg-white dark:bg-dark-secondary ${
            darkMode ? "" : "shadow-box_shadow_1"
          }`}
        >
          <div className="absolute right-0 bottom-0">
            <BottomEllips className="h-28 md:h-auto" />
          </div>
          <div className="md:flex items-center">
            <div className="hidden md:block md:w-[40%] bg-[#FBF7F7] dark:bg-dark-primary p-5 xl:p-10 rounded-[20px]">
              <div className="px-2.5 ">
                <p className="text-body_copy2_black xl:text-body_copy1_b -tracking-[0.8px] text-heading_color dark:text-color_v1_dark mb-[20px] xl:mb-[30px]">
                  {translate("descriptions.order_summary")}
                </p>
                <div className="flex flex-col gap-3 xl:gap-4">
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("addBlock.plan")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                      {(paymentData?.plan_details?.isFree && "Free") ||
                        "Premium"}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("descriptions.type")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                      {paymentData?.payment_detail?.interval === "month"
                        ? translate("monthly")
                        : translate("addBlock.annually")}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("addBlock.renewal")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                      {translate("addBlock.auto")}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("descriptions.paid_with")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold dark:text-color_v2_dark">
                      Stripe
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("descriptions.price")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold text-main_color">
                      ${paymentData?.payment_detail?.amount}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-small2 xl:text-small1 dark:text-color_v2_dark">
                      {translate("addBlock.inclusive_tax")}
                    </p>
                    <p className="text-small2_b xl:text-small1_bold text-main_color">
                      $0
                    </p>
                  </div>

                  {paymentData?.coupon && (
                    <div className="flex justify-between">
                      <p className="text-small2 xl:text-small1">
                        Discount Coupon
                      </p>
                      <p className="text-small2_b xl:text-small1_bold text-main_color">
                        - ${paymentData?.payment_detail?.coupon_discount}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <hr className="mt-[30px] border" />
              <div className="flex justify-between mt-[20px] xl:mt-[30px] px-2.5">
                <p className="text-body_copy2_black xl:text-body_copy1_b dark:text-color_v1_dark">
                  {translate("descriptions.total_amount")}
                </p>
                <p className="text-body_copy2_black xl:text-body_copy1_b dark:text-color_v1_dark">
                  ${paymentData?.payment_detail?.amount}
                </p>
              </div>
            </div>
            <div className="text-center md:w-[60%]">
              <div className="w-full flex justify-center items-center">
                <div>
                  <SuccessIcon className="h-[100px] w-[100px] sm:h-[120px] sm:w-[120px]" />
                </div>
              </div>
              <h1 className="text-custom_h5 xl:text-custom_h4 text-main_color mt-[26px] xl:mt-[30px] mb-10 xl:mb-[50px]">
                {translate("addBlock.payment_successful")}
              </h1>
              <h6 className="text-body_copy2_black xl:text-custom_h6 text-heading_color dark:text-color_v2_dark">
                <span className="text-main_color">
                  {translate("addBlock.enjoy")}
                </span>{" "}
                {translate("addBlock.using_premium_and_continue")}{" "}
                <br className="hidden sm:block" />{" "}
                {translate("addBlock.exclusive_biolinks")}.
              </h6>
            </div>
          </div>
        </div>
        <div
          className={`rounded-[20px] relative z-30 py-[30px] p-5 md:hidden mb-[80px] bg-[#F6F0E4] dark:bg-dark-primary border dark:border-color_v2_dark ${
            darkMode ? "" : "shadow-box_shadow_1"
          }`}
        >
          <div className="px-2.5">
            <p className="text-body_copy2_black text-heading_color mb-5 dark:text-color_v1_dark">
              {translate("descriptions.order_summary")}
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("addBlock.plan")}
                </p>
                <p className="text-small2_b dark:text-color_v2_dark">
                  {(paymentData?.plan_details?.isFree && "Free") || "Premium"}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("descriptions.type")}
                </p>
                <p className="text-small2_b dark:text-color_v2_dark">
                  {paymentData?.payment_detail?.interval === "month"
                    ? translate("monthly")
                    : translate("addBlock.annually")}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("addBlock.renewal")}
                </p>
                <p className="text-small2_b dark:text-color_v2_dark">
                  {paymentData?.renewal === false
                    ? "Off"
                    : translate("addBlock.auto")}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("descriptions.paid_with")}{" "}
                </p>
                <p className="text-small2_b dark:text-color_v2_dark">Stripe</p>
              </div>
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("descriptions.price")}
                </p>
                <p className="text-small2_b text-main_color">
                  ${paymentData?.payment_detail?.amount}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-small2 dark:text-color_v2_dark">
                  {translate("addBlock.inclusive_tax")}
                </p>
                <p className="text-small2_b text-main_color">$0</p>
              </div>
              {paymentData?.coupon && (
                <div className="flex justify-between">
                  <p className="text-small2 dark:text-color_v2_dark">
                    Discount Coupon
                  </p>
                  <p className="text-small2_b text-main_color">
                    - ${paymentData?.payment_detail?.coupon_discount}
                  </p>
                </div>
              )}
            </div>
          </div>
          <hr className="mt-[30px]  border" />
          <div className="flex justify-between mt-5 px-2.5">
            <p className="text-body_copy2_black dark:text-color_v1_dark">
              {translate("descriptions.total_amount")}
            </p>
            <p className="text-body_copy2_black dark:text-color_v1_dark">
              ${paymentData?.payment_detail?.amount}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
